<template>
  <div>
    <h2 v-if="!isEditing" class="Title">
      {{ groupName }}
      <!-- <v-btn icon @click="toggleEditing"> <v-icon class="mdi mdi-pencil-outline"></v-icon></v-btn> -->
    </h2>
    <div v-else style="height: 37px;margin-bottom: 18px;">
      <v-row>
        <v-col cols="2">
          <v-text-field dense v-model="editedGroupName" @keyup.enter="saveGroupName"
            style="font-size: 24px;font-weight: bold; padding: 0px;" />
        </v-col>
        <v-col cols="1">
          <v-btn icon @click="saveGroupName"> <v-icon class="mdi mdi-check"></v-icon></v-btn>
        </v-col>
      </v-row>


    </div>

    <v-row>
      <v-col cols="5">
        <SearchTextfield v-if="groupId === 'all'" />
        <PlayerUrlCopy v-if="groupId !== 'all'" :group-id="groupId" @updateUrl="handleUpdateUrl" />
      </v-col>
      <v-col class="text-right mb-2" v-if="groupId === 'all'">
        <TextButton icon="mdi-plus" buttonText="그룹화" @click="openGroupDialog"
          :disabled="this.selectedItems.length === 0" isPrimary />
      </v-col>
      <v-col class="text-right mb-2" v-if="groupId !== 'all'">
        <IconButton icon="mdi-plus" class="mr-2" @click="showAllListDialog" />
        <IconTextButton icon="mdi-play-circle-outline" buttonText="재생" @click="openModal" />
      </v-col>
    </v-row>

    <!-- 그룹화-->
    <AppDialog :value="showGroupDialog" :persistent="true" @input="showGroupDialog = $event">
      <template v-slot:title>
        <span>그룹화 설정</span>
      </template>
      <!-- <template v-slot:close>
        <v-icon @click="closeGroupDialog">mdi-close</v-icon>
      </template> -->
      <template v-slot:content>
        <v-data-table :headers="dialogHeaders" :items="dialogItems" show-select item-key="id" :items-per-page="40"
          v-model="selectedGroup" hide-default-footer fixed-header height="220px" class="data-table elevation-0">
        </v-data-table>
      </template>
      <template v-slot:actions>
        <TextButtonBlock buttonText="취소" @click="closeGroupDialog" />
        <TextButtonBlock buttonText="추가" @click="grouping" isPrimary />
      </template>
    </AppDialog>


    <!-- 전체리스트-->
    <AppDialogLarge :value="showPlaylistDialog" :persistent="true" @input="showPlaylistDialog = $event">
      <template v-slot:title>
        <span>리스트 추가</span>
      </template>
      <!-- <template v-slot:close>
        <v-icon small @click="closePlaylistDialog">mdi-close</v-icon>
      </template> -->
      <template v-slot:content>
        <v-data-table v-model="selected" :headers="headers" :items="items" :items-per-page="itemsPerPage" 
        :footer-props="footerProps"
        :server-items-length="totalItems" :options.sync="options"
        @update:page="fetchPlaylist" @update:items-per-page="updateItemsPerPage"
        item-key="id" show-select class="data-table elevation-0">
          <template #[`item.name`]="{ item }">
            <div style="word-break:break-all;">{{ item.name }}</div>
          </template>
          <template #[`item.image`]="{ item }">
            <div class="image-container ma-1">
              <img :src="item.image"
                style="position: absolute; height: 100%; top: 0; object-fit: contain; object-position: top center;padding: 0;"
                :contain="true" />
            </div>
          </template>
        </v-data-table>
      </template>
      <template v-slot:actions>
        <TextButtonBlock buttonText="취소" @click="handleClosePlaylistDialog" />
        <TextButtonBlock buttonText="추가" isPrimary @click="addPlaylistToGroup" />
      </template>
    </AppDialogLarge>


    <PlayerModal ref="playerModal" v-model="dialog" :url="playerUrl" />


    <!-- <PlayerModal v-if="dialog" v-model="dialog" :group-id="groupId" key="groupId" /> -->



  </div>
</template>

<script>
import PlayerModal from '@/components/app/AppPlayer.vue';
import IconTextButton from '@/components/ui/button/IconTextButton.vue';
import IconButton from '@/components/ui/button/IconButton.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import TextButton from '@/components/ui/button/TextButton2.vue';
// import SearchTextfield from '@/components/app/AppSearchField.vue';
import SearchTextfield from '@/components/playlist/SearchTextfield.vue';
import PlayerUrlCopy from '@/components/playlist/PlayerUrlCopy.vue';
import { mapActions, mapGetters } from 'vuex';
import AppDialog from '@/components/app/AppDialog.vue';
import AppDialogLarge from '@/components/app/AppDialogLarge.vue';
import PlaylistApi from "@/api/playlist/PlaylistApi";

export default {
  components: {
    IconTextButton,
    IconButton,
    SearchTextfield,
    AppDialogLarge,
    PlayerUrlCopy,
    PlayerModal,
    TextButtonBlock,
    TextButton,
    AppDialog
  },
  props: {
    groupId: {
      type: [Number, String],
      required: true,
    }
  },
  data() {
    return {
      showGroupDialog: false,
      showPlaylistDialog: false,
      selectedGroup: [],
      dialogItems: [],
      items: [],
      dialog: false,
      uuid: '',
      playerUrl: '',
      dialogHeaders: [
        { text: '그룹명', value: 'dialogGroupName' },
      ],
      cachedGroups: {},
      cachedPlaylists: {},
      headers: [
        { text: '썸네일', value: 'image' },
        { text: '파일 이름', value: 'name' },
        // { text: '그룹', value: 'groupNames' },
        // { text: '재생 시간', value: 'runtime' },
      ],
      itemsPerPage: 10,
      isEditing: false,
      editedGroupName: '',
      currentPage: 1,
      totalItems: 0,
      footerProps: {
        itemsPerPageOptions: [10, 15, 30],
        itemsPerPageText: '항목 수',
        page: 1,
        pageStart:1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      options: {
        page: 1,
        itemsPerPage: 10,
      },

      loading: false, 
    };
  },
  methods: {
    ...mapActions('group', ['updateSelectedGroupId', 'updateSelectedGroupName']),
    async closeGroupDialog() {
      this.selectedGroup = [];
      this.showGroupDialog = false;
    },
    openModal() {
      this.$nextTick(() => {
        this.$refs.playerModal.setGroupId(this.playerUrl);
      });
      this.dialog = true;
    },
    handleUpdateUrl(url) {
      this.playerUrl = url;
    },
    updateFooterProps() {
      this.footerProps = {
        itemsPerPageOptions: [10, 15, 30],
        itemsPerPageText: '항목 수',
        page: this.options.page,
        itemsPerPage: this.options.itemsPerPage,
        totalItems: this.totalItems,
      };
    },
    handleClosePlaylistDialog() {
      this.options.page = 1;
      this.options.itemsPerPage = 10;
      this.updateFooterProps();
      this.$nextTick(() => {
        this.showPlaylistDialog = false;
      });
    },
    async closePlaylistDialog() {
      this.selected = [];
      this.options.page = 1;
      this.options.itemsPerPage = 10;
      this.updateFooterProps();
      this.showPlaylistDialog = false;
    },
    async openGroupDialog(page = 1) {
      this.showGroupDialog = true;
      try {
        const response = await PlaylistApi.groupListPagingApi(page);
        const processedData = response.data.map(item => ({
          id: item.id,
          dialogGroupName: item.group_name
        }));
        this.dialogItems = processedData;
      } catch (error) {
        console.error('error', error);
      }
    },
    updateItemsPerPage(itemsPerPage) {
      this.itemsPerPage = itemsPerPage;
      this.fetchPlaylist(1, itemsPerPage);
    },
    async grouping() {
      const assetIds = this.selectedItems.map(item => item.id);
      const playlistIds = this.selectedGroup.map(item => item.id);
      await this.$store.dispatch('group/grouping', { assetIds, playlistIds });
      this.selectedGroup = [];
      this.showGroupDialog = false;
    },
    async addPlaylistToGroup() {
      const assetIds = this.selected.map(item => item.id);
      const groupId = this.groupId;
      //console.log('group', groupId);
      await this.$store.dispatch('group/addPlaylistToGroup', { assetIds, groupId });
      this.handleClosePlaylistDialog();
    },
    async showAllListDialog(){
      this.options.page = 1;
      this.options.itemsPerPage = 10;
      this.fetchPlaylist(this.options.page, this.options.itemsPerPage);
      this.showPlaylistDialog = true;
    },
    ...mapActions('search', ['resetSearch']),
    async fetchPlaylist(page = this.options.page, itemsPerPage = this.options.itemsPerPage) {
      this.loading = true;
      this.showPlaylistDialog = true;
      // const groupId = this.groupId;
      this.options.page = page;
      this.options.itemsPerPage = itemsPerPage;
      this.resetSearch(); 
      this.updateFooterProps();
      const query = '';
      try {
        const response = await PlaylistApi.allPlaylistApi(this.options.page, this.options.itemsPerPage, query);
        const processedData = response.data.map(item => ({
          id: item.id,
          name: item.name,
          // runtime: item.runtime,
          // groupNames: Object.values(item.group_names),
          image: item.posterImg ? item.posterImg : "https://ceph01rgw.streamon.co.kr:47043/streamon01/logo/streamon.png",
        }));
        this.totalItems = parseInt(response.total, 10);
        this.items = processedData;
        this.updateFooterProps();
      } catch (error) {
        console.error('error', error);
      } finally {
        this.loading = false;
      }

    },

    toggleEditing() {
      this.isEditing = !this.isEditing;
      if (this.isEditing) {
        // 본래 그룹 이름 저장
        this.editedGroupName = this.groupName;
      }
    },
    saveGroupName() {
      // 변경된 그룹 이름 저장
      this.groupName = this.editedGroupName;
      // 편집 모드 종료
      this.isEditing = false;
    }

  },
  computed: {
    ...mapGetters('group', ['selectedItems']),
    // groupId() {
    //   return this.$store.state.group.selectedGroupId;
    // },
    groupName() {
      return this.$store.state.group.selectedGroupName;
    },
    isGroupButtonDisabled() {
      return this.selectedItems.length === 0;
    },
    selected: {
      get() {
        return this.$store.state.group.selectedItems;
      },
      set(value) {
        this.$store.dispatch('group/updateSelectedItems', value);
      }
    },
  },
  watch: {
    groupId(newValue, oldValue) {
      if (newValue !== oldValue) {

      }
    },
    selectedItems(newVal) {
      if (newVal.length > 0) {

      }
    },
    selectedGroup(newVal) {

    },
    selected(newVal, oldVal) {
      //console.log('Selected items changed:', newVal);
    },
    showPlaylistDialog(newVal) {
      if (!newVal) {
        this.options.page = 1;
        this.options.itemsPerPage = 10;
        this.updateFooterProps();
      }
    }

  }

};
</script>

<style>
.v-data-footer__pagination {
  justify-content: flex-end !important;
}
</style>